module.exports = __webpack_public_path__ + "./images/98d72988c6de741302dbdad3c2529fb1.webp";